import { PLATFORM } from 'aurelia-framework';
import { roles } from 'routes';

export const mooring_routes = [
  {
    route: ['mooring/component-templates'],
    name: 'mooring-component-templates',
    settings: { roles: [roles.mooringcalculation, roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-component-templates/template-view') },
      side: { moduleId: null },
    },
    title: 'mooring.componentTemplates',
    route_base: 'mooring/component-templates',
    section: 'mooring',
  },
  {
    route: ['mooring/offers'],
    name: 'mooring-offers-view',
    settings: { roles: [roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-offers/offers-view') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'mooring.offer',
    route_base: 'mooring/offers',
    section: 'mooring',
  },
  {
    route: ['mooring/offers/:id'],
    name: 'mooring-offer-view',
    settings: { roles: [roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-offers/offer-view') },
      side: { moduleId: null },
    },
    route_base: 'mooring/offers',
    section: 'mooring',
  },
  {
    route: ['mooring/board/offers'],
    name: 'mooring-offers-board',
    settings: { roles: [roles.mooringcalculation, roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-offers/board/board-view-offer') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'mooring.offerBoard',
    route_base: 'mooring/board/offers',
    section: 'mooring',
  },
  {
    route: ['mooring/production-orders'],
    name: 'mooring-production-orders-view',
    settings: { roles: [roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-orders-view') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'mooring.production',
    route_base: 'mooring/production-orders',
    section: 'mooring',
  },
  {
    route: ['mooring/production-orders/:id'],
    name: 'mooring-production-orders-view',
    settings: { roles: [roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-production-orders/production-order-view') },
      side: { moduleId: null },
    },
    route_base: 'mooring/production-orders',
    section: 'mooring',
  },
  {
    route: ['mooring/board/productions'],
    name: 'mooring-production-board',
    settings: { roles: [roles.mooringcalculation, roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-production-orders/board/board-view-production') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'mooring.productionBoard',
    route_base: 'mooring/board/productions',
    section: 'mooring',
  },
  {
    route: ['mooring/orders'],
    name: 'mooring-salesorder-view',
    settings: { roles: [roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-salesorder/salesorder-view') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'general.salesOrder',
    route_base: 'mooring/orders',
    section: 'mooring',
  },
  {
    route: ['mooring/certificates'],
    name: 'certificate-view',
    settings: { roles: [roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-certificate/certificate-view') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'general.certificates',
    route_base: 'mooring/certificates',
    section: 'mooring',
  },
  {
    route: ['mooring/calculation-report'],
    name: 'mooring-calculation-report',
    settings: { roles: [roles.mooringcalculation, roles.mooringAdministrator], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('components/mooring-calculation-report/mooring-calculation-report-new') },
      side: { moduleId: null },
    },
    nav: true,
    title: 'mooringCalculationReport.title',
    route_base: 'mooring/calculation-report',
    section: 'mooring',
  },
  {
    route: ['mooring/:mooringId/map'],
    name: 'mooring-map',
    settings: { roles: [roles.mooringAdministrator, roles.mooringSeller], searchable: true },
    viewPorts: {
      main: { moduleId: PLATFORM.moduleName('views/mooring/mooring-map/mooring-map-view') },
      side: { moduleId: null },
    },
  },
];
